import { Env } from '@stencil/core';
import { ProductWidgetEnvironment } from './environment-schema';

export const enum AppEnvironment {
  DEV = 'development',
  STAGING = 'staging',
  PRODUCTION = 'production',
}

const appEnvironments = {
  [AppEnvironment.DEV]: () =>
    import('./environment.development').then((m) => m.environment),
  [AppEnvironment.STAGING]: () =>
    import('./environment.staging').then((m) => m.environment),
  [AppEnvironment.PRODUCTION]: () =>
    import('./environment.production').then((m) => m.environment),
};

export function getEnvironment(): Promise<ProductWidgetEnvironment> {
  return appEnvironments[Env.APP_ENVIRONMENT as AppEnvironment]();
}
